module.exports = __webpack_public_path__ + "2400c05666bf3d2af49acbd163682997.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/MyriadPro-Cond.ttf
// module id = 163
// module chunks = 0